import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateToppingGroup = async (placeId, toppingGroupId, update) => {
  if (!placeId || !toppingGroupId || !update) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/toppings-groups/${toppingGroupId}/update`,
    data: update,
  });
};